function addCurrencyQueryParam(code) {
  const url = new URL(window.location.href);

  if (!url.searchParams.has('currency')) {
    url.searchParams.append('currency', code);
    window.history.pushState({ path: url.href }, '', url.href);
    window.location.reload();
  }
}

if(!localStorage.getItem("forcedCurrencySelection")) {
  fetch('https://api.ipgeolocation.io/ipgeo?apiKey=d7c83eb0d2dd40f791ccb65bab1768af')
    .then(response => response.json())
    .then(data => {

      if(window.Shopify.currency.active === data.currency.code) return
      if(data.country_code2 === 'US') {
        addCurrencyQueryParam(data.currency.code)
      }
    })
}